import { CalendarEvent } from "../../serviceModuleTypes";
import { BaseSubtypeDataModel } from "../subtypeData";

export interface SurveyAppointmentSubtypeDataModel extends BaseSubtypeDataModel {
    eventAnswers: EventWithAnswer[];
    noEventViable: boolean;
}

export interface EventWithAnswer {
    event: CalendarEvent;
    answer: SurveyEventAnswer;
}

export enum SurveyEventAnswer {
    Accepted = "Accepted",
    Declined = "Declined"
}